module.exports = __webpack_public_path__ + "img/banner2.6c1fde16.png";